module.exports = __webpack_public_path__ + "img/ai.16ece2a3.jpg";